export default __webpack_public_path__ + "static/media/document-thumbnail.c23b7465.svg";